import type { MonospaceKeyStorage } from '#layers/data-model';
import { RStoreSchema } from '#imports';

export const KeyStorage = RStoreSchema.withItemType<MonospaceKeyStorage>().defineCollection({
	name: 'MonospaceKeyStorage',
	scopeId: 'monospace-default',
	getKey: (item) => item.key,
	meta: {
		defaultFields: ['key', 'value', 'ownerId', 'blockId', 'collectionId'],
		useProjectSlug: true,
		endpoint: 'key-storage',
	},
});
